import { Skeleton } from '../ui/skeleton';

const NotificationSkeleton = () => (
    <div className="py-2 border-b border-neutral-300">
        <Skeleton className="h-5 w-1/2 mb-2" />
        <Skeleton className="h-4 w-full mb-2" />
        <div className="flex justify-between">
            <Skeleton className="h-3 w-1/4" />
            <Skeleton className="h-3 w-1/4" />
        </div>
    </div>
);

export default NotificationSkeleton;
